import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskTicketTypesConfigRoute: InvariantJiraRoute = {
	exact: true,
	name: 'project-settings-servicedesk-ticket-types-config',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types',
};
